import { Col, Image, Section, Wrapper } from '@ahmdigital/ui';
import { compact, contains } from 'lodash/fp';
import { ReactNode } from 'react';

import { AlignableRow } from '../../pages/product/components/styles';
import commonThemes from '../../application/common/theme.module.sass';
import styles from './styles.module.sass';

const NARROW_VARIANT = {
  df: 7,
  sm: 12,
};

const FULL_WIDTH_VARIANT = {
  df: 10,
  dfOffset: 2,
  sm: 12,
  smOffset: 0,
};

type PageStripProps = {
  image: string;
  text: ReactNode;
  variant?: string[];
};

const PageStrip = ({ image, text, variant = undefined }: PageStripProps) => (
  <Section
    variant={compact([
      styles.contentSection,
      commonThemes.white,
      contains('noHorizontalMargin', variant) ? styles.noHorizontalMargin : null,
    ])}
  >
    <Wrapper>
      <AlignableRow centered>
        <Col {...(contains('narrow', variant) ? NARROW_VARIANT : FULL_WIDTH_VARIANT)}>
          <div className={styles.container}>
            {contains('illustration', variant) ? (
              <Image src={image} role="presentation" className={styles.illustration} />
            ) : (
              <Image src={image} role="presentation" className={styles.image} />
            )}
            <div className={styles.text}>{text}</div>
          </div>
        </Col>
      </AlignableRow>
    </Wrapper>
  </Section>
);

export default PageStrip;
